import React from 'react';
import Navigation from './navigation';
import Footer from './footer';
import './PrivacyPolicy.css';

const ORG_NAME = 'Ren Nushaj for MI State Senate';
const CONTACT_EMAIL = 'office@ren4misenate.com';
const MAILING_ADDRESS = '5960 Livernois, Troy, MI 48098';

// Update whenever the policy text changes.
const LAST_UPDATED = 'July 21, 2026';

const PrivacyPolicy = () => (
  <>
    <div className="fixed top-0 left-0 right-0 z-50">
      <Navigation />
    </div>

    <div className="hero-section2">
      <div className="page-title">Privacy Policy</div>
    </div>

    <div className="policy-container">
      <div className="policy-card">
        <p className="policy-updated">Last updated: {LAST_UPDATED}</p>

        <p>
          {ORG_NAME} ("we," "us," or "our") respects your privacy. This Privacy Policy
          explains what information we collect when you visit our website, sign up for
          updates, attend our events, or contact our campaign, how we use that
          information, and the choices you have about it.
        </p>

        <h2>Information We Collect</h2>
        <p>We collect the following categories of information:</p>
        <ul>
          <li>
            <strong>Information you give us.</strong> Your name, email address, mobile
            phone number, mailing address or ZIP code, and any message you send us when
            you subscribe to updates, opt in to text messages, RSVP to an event, volunteer,
            or use a contact form on this site.
          </li>
          <li>
            <strong>Event and volunteer information.</strong> Details you provide when you
            RSVP, such as guest counts and accessibility or dietary needs.
          </li>
          <li>
            <strong>Automatically collected information.</strong> Standard technical data
            such as your IP address, browser type, device type, referring page, and the
            pages you view, collected through cookies and similar analytics technologies.
          </li>
        </ul>
        <p>
          We do not collect contribution or payment card information on this website.
          Donations are processed by a third-party payment processor under its own privacy
          policy and applicable campaign finance law.
        </p>

        <h2>How We Use Your Information</h2>
        <ul>
          <li>To send you campaign news, event invitations, and other updates you request.</li>
          <li>To respond to your questions, comments, and volunteer inquiries.</li>
          <li>To organize events and manage RSVPs.</li>
          <li>To share voter registration and voting information.</li>
          <li>To improve this website and understand how supporters use it.</li>
          <li>To meet our obligations under applicable campaign finance and election law.</li>
        </ul>

        <h2>Mobile Messaging</h2>
        <p>
          We may send you SMS text messages if you have opted in to receive them. Mobile
          information, including your phone number and opt-in consent, will not be shared
          with third parties or affiliates for marketing or promotional purposes.
        </p>
        <p>
          All categories of personal information described in this policy exclude text
          messaging originator opt-in data and consent. This information will not be
          shared with any third parties.
        </p>
        <p>
          If you opt in, the messages you may receive include event invitations and
          reminders, fundraising appeals and donation requests, endorsement announcements,
          voter registration reminders and voting information, volunteer opportunities and
          recruitment, and general campaign news and updates.
        </p>
        <p>
          Message and data rates may apply. Message frequency varies. Reply{' '}
          <strong>STOP</strong> to any message to cancel, or <strong>HELP</strong> for
          help. You can also opt in or review our messaging terms on our{' '}
          <a href="/sms-opt-in">text message sign-up page</a>.
        </p>

        <h2>How We Share Information</h2>
        <p>
          We do not sell your personal information. We may share information only in these
          limited circumstances:
        </p>
        <ul>
          <li>
            <strong>Service providers.</strong> With vendors who operate this website, send
            our email and text messages, or host our data, and only so they can perform
            those services for us.
          </li>
          <li>
            <strong>Legal requirements.</strong> When required by law, including campaign
            finance reporting, subpoenas, or other legal process.
          </li>
          <li>
            <strong>Safety.</strong> To protect the rights, property, or safety of the
            campaign, our supporters, or the public.
          </li>
        </ul>
        <p>
          As stated above, mobile phone numbers and SMS opt-in consent are never shared
          with third parties or affiliates for marketing or promotional purposes.
        </p>

        <h2>Cookies and Analytics</h2>
        <p>
          This site uses cookies and similar technologies, including third-party analytics
          and advertising measurement pixels, to understand site traffic and improve our
          outreach. Most browsers let you refuse or delete cookies through their settings.
          Blocking cookies may affect how parts of this site work.
        </p>

        <h2>Your Choices</h2>
        <ul>
          <li>
            <strong>Text messages:</strong> Reply <strong>STOP</strong> to any message from
            us to stop receiving texts.
          </li>
          <li>
            <strong>Email:</strong> Use the unsubscribe link in any campaign email, or
            email us at <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          </li>
          <li>
            <strong>Access and deletion:</strong> Email us to ask what information we hold
            about you or to request that we delete it. We will honor these requests except
            where we are required to retain records by law.
          </li>
        </ul>

        <h2>Data Security</h2>
        <p>
          We use reasonable administrative, technical, and physical safeguards to protect
          the information we collect. No method of transmission or storage is completely
          secure, so we cannot guarantee absolute security.
        </p>

        <h2>Children's Privacy</h2>
        <p>
          This website is not directed to children under 13, and we do not knowingly
          collect personal information from them. If you believe a child has provided us
          information, please contact us and we will delete it.
        </p>

        <h2>Third-Party Links</h2>
        <p>
          Our site links to other websites, including social media and our donation
          processor. We are not responsible for their privacy practices, and we encourage
          you to read their privacy policies.
        </p>

        <h2>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. When we do, we will revise
          the "Last updated" date at the top of this page.
        </p>

        <h2>Contact Us</h2>
        <p>
          Questions about this Privacy Policy or your information? Contact us at:
          <br />
          {ORG_NAME}
          <br />
          {MAILING_ADDRESS}
          <br />
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </p>
      </div>
    </div>

    <Footer />
  </>
);

export default PrivacyPolicy;
